module.exports = require("@azure/msal-node-extensions");